import React, { forwardRef, useImperativeHandle } from 'react'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph, useOverlay } from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { Trans } from 'react-i18next'

function InvalidGroupIdsDialog({ invalidGroupIds }, ref) {
  const overlay = useOverlay()
  useImperativeHandle(ref, () => overlay)

  return (
    <DialogOverlay
      {...overlay}
      title={i18n.t('InvalidGroupIdsDialog.title.incorrectGroupIds', 'Incorrect Group ID(s)')}
    >
      <Paragraph>
        <Trans
          components={[<strong />]}
          default="Could not display any volume sets for <0>{groupIds}</0>"
          i18nKey="InvalidGroupIdsDialog.content.couldNotDisplayVolumeSets"
          values={{ groupIds: invalidGroupIds?.join(', ') }}
        />
      </Paragraph>

      <DialogOverlayActions>
        <Button emphasis="high" onClick={overlay.close}>
          {i18n.t('common-ui:continue.action')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}

export default forwardRef(InvalidGroupIdsDialog)
